import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Restaurateur / super-admin client (uses foodgo_token in localStorage via Bearer header)
// withCredentials must stay false: cross-domain (foodgo.renova360.it → orderup-renova.emergent.host)
// would otherwise hit the K8s edge wildcard CORS header and be rejected by the browser.
const client = axios.create({ baseURL: API, withCredentials: false });
client.interceptors.request.use((config) => {
  const t = localStorage.getItem("foodgo_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Customer client (uses foodgo_customer_token — separate from restaurateur)
export const customerClient = axios.create({ baseURL: API, withCredentials: false });
customerClient.interceptors.request.use((config) => {
  const t = localStorage.getItem("foodgo_customer_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Public client (no auth)
export const publicClient = axios.create({ baseURL: API });

export default client;
